import axios from 'axios';
import axiosRetry from 'axios-retry';

export const uploadClient = axios.create({
  // No timeout — large video files can take minutes.
  // Cancellation is handled via AbortController.
});

axiosRetry(uploadClient, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
  retryCondition: (error) =>
    // Only retry on network errors, not on timeouts or completed requests.
    // Retrying a partially-uploaded large file restarts from byte 0.
    axiosRetry.isNetworkError(error),
});
